import { useMemo } from 'react';
import { useTheme } from 'styled-components';
const getNumberOfTrailingChildren = (numberOfGridItems, columns, theme) => {
    if (typeof columns === 'number') {
        return numberOfGridItems % columns;
    }
    if (typeof window === 'undefined' || typeof document === 'undefined') {
        return numberOfGridItems % columns.sm;
    }
    if (window.innerWidth > Number(theme.viewportBreakpoint.md)) {
        return numberOfGridItems % columns.lg;
    }
    if (window.innerWidth > Number(theme.viewportBreakpoint.sm)) {
        return numberOfGridItems % columns.md;
    }
    return numberOfGridItems % columns.sm;
};
export default (numberOfGridItems, columns) => {
    const theme = useTheme();
    return useMemo(() => getNumberOfTrailingChildren(numberOfGridItems, columns, theme), [numberOfGridItems, columns, theme]);
};
